import { useQuery } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { docksForPlantWithIdQueryKey } from "./plantQueryKeys";
import { plantDockUrls } from "../../URL/ApplicationUrls";
import { PlantDock } from "../PlantDock";

export const useFetchDocksForPlant = (plantId: number | string | undefined) => {
  return useQuery<PlantDock[], Error>({
    queryKey: docksForPlantWithIdQueryKey(plantId),
    queryFn: () => fetchDocks(plantId),
    onSuccess: (docks: PlantDock[]) =>
      docks.map((it) => ({
        ...it,
        IsNewDock: false,
      })),
    onError: () => {
      toast.error(`An error occurred when retrieving docks for the plant with Id ${plantId}`);
    },
  });
};

const fetchDocks = async (plantId: number | string | undefined) => {
  const { data: plant } = await axios.get<PlantDock[]>(plantDockUrls.docksForPlantWithId(plantId));
  return plant;
};
